import { render, staticRenderFns } from "./WasteUnitSettings.vue?vue&type=template&id=2f90ca60&"
import script from "./WasteUnitSettings.vue?vue&type=script&lang=js&"
export * from "./WasteUnitSettings.vue?vue&type=script&lang=js&"
import style0 from "./WasteUnitSettings.vue?vue&type=style&index=0&id=2f90ca60&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f90ca60')) {
      api.createRecord('2f90ca60', component.options)
    } else {
      api.reload('2f90ca60', component.options)
    }
    module.hot.accept("./WasteUnitSettings.vue?vue&type=template&id=2f90ca60&", function () {
      api.rerender('2f90ca60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/waste/modal/WasteUnitSettings.vue"
export default component.exports